import { render, staticRenderFns } from "./le-survey-choose.vue?vue&type=template&id=046fc87c&scoped=true&"
import script from "./le-survey-choose.vue?vue&type=script&lang=js&"
export * from "./le-survey-choose.vue?vue&type=script&lang=js&"
import style0 from "./le-survey-choose.vue?vue&type=style&index=0&id=046fc87c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046fc87c",
  null
  
)

export default component.exports